import React from "react";
import { useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import PreviewPop from "./previewPop";
import {
  CFormGroup,
  CCol,
  CCardBody,
  CButton,
  CLabel,
  CContainer,
} from "@coreui/react";
import Swal from "sweetalert";
import ApiHelper from "src/utils/api/api_helper";
import { useHistory } from "react-router-dom";

const SubmissionPage = () => {
  const state = useSelector((state) => state);
  const { main, insert } = useSelector((state) => state);
  const history = useHistory();
  const [formList, setFormList] = React.useState([]);
  const [checkItems, setCheckItems] = React.useState([]);
  const singleCheck = document.getElementsByName("singleCheck");
  const etcAfcoList = ['10025', '10010', '10011', '10026', '10009', '10008', '10024', '10013', '10004' , '10021', '10031', '10029', '10005', '10012', '10023', '10022', '10001'];
  const [previewPop, setPreviewPop] = React.useState({
    isOpen: false,
    form: null,
  });
  const chkAfcrList = state.apoDocForm.apoDocCnfmYn.filter((item) => item.cnfmYn).map((item) => item.afcrNo);

  const handleAllCheck = (checked) => {
    if (checked) {
      const idArray = [];
      singleCheck.forEach((item) => {
        idArray.push(item.value);
      });
      setCheckItems(idArray);
    } else {
      setCheckItems([]);
    }
  };

  const handleSingleCheck = (checked, value) => {
    if (checked) {
      setCheckItems([...checkItems, value]);
    } else {
      setCheckItems(checkItems.filter((item) => item !== value));
    }
  };

  const handleSubmission = async () => {
    // const { reqNo } = state.insert.reqTaskInfo;
    // const { ifKey } = state.main.corpNm;
    // let params = { reqNo, ifKey };

    // 입력정보 누락 방지
    if(insert.reqTaskInfo.brNo == null || insert.reqTaskInfo.brNo == ""){
      return Swal("지점명", "협회등록지점이 선택되지 않았습니다.\n이전 단계로 돌아가 선택 후 제출해주세요.", "info");
    }
    if(insert.reqTaskInfo.resRegNoBack == null || insert.reqTaskInfo.resRegNoBack.trim() == ""){
      return Swal("주민등록번호", "주민등록번호 뒷자리가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if(insert.reqTaskInfo.postNo == null || insert.reqTaskInfo.postNo == "" || insert.reqTaskInfo.addr == null || insert.reqTaskInfo.addr == ""){
      return Swal("주소", "주소가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if(state.main.taskNo == '52' || state.main.taskNo == '53'){
      if(insert.reqTaskInfo.emalAddr == null || insert.reqTaskInfo.emalAddr.trim() == "" || insert.reqTaskInfo.emalDmn == null || insert.reqTaskInfo.emalDmn.trim() == ""){
        return Swal("이메일주소", "이메일주소가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
      }
    }
    // #15808 유치자정보 필수 -> 선택 변경
    // if(insert.reqTaskInfo.recrNm == null || insert.reqTaskInfo.recrNm == ''){
    //   return Swal("유치자명", "유치자명이 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    // }
    // if(insert.reqTaskInfo.recrTel == null || insert.reqTaskInfo.recrTel == ''){
    //   return Swal("유치자연락처", "유치자연락처가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    // }
    // if(insert.reqTaskInfo.recrOflv == null || insert.reqTaskInfo.recrOflv == ''){
    //   return Swal("유치자직위", "유치자직위가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    // }
    // if(insert.reqTaskInfo.recrEmpNo == null || insert.reqTaskInfo.recrEmpNo == ''){
    //   return Swal("유치자사번", "유치자사번이 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    // }
    if(insert.reqTaskInfo.natlNm == null || insert.reqTaskInfo.natlNm == ''){
      return Swal("국적", "국적이 선택되지 않았습니다.\n이전 단계로 돌아가 선택 후 제출해주세요.", "info");
    }

    for (let item of singleCheck) {
      if (!item.checked)
        return Swal(
          "원본서류",
          `${item.dataset.title}가 체크되지 않았습니다.`,
          "error"
        );
    }

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/submission",
      {
        reqNo: state.insert.reqTaskInfo.reqNo,
        ifKey: state.main.corpNm,
      }
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          history.push(`/${state.main.corpNm}/8`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  let params = {
    corpNo: state.main.corpNo,
    taskNo: state.main.taskNo,
  };

  React.useEffect(() => {
    const setCorpFormList = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/corpFormList",
        params
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            const result = data.data;
            let formList = [];

            formList = result.filter((item) => item.AFCR_NO === '' || chkAfcrList.indexOf(String(item.AFCR_NO)) > -1);

            setFormList(formList);

            if (
              state.insert.reqTaskInfo.stCd !== "10" &&
              state.insert.reqTaskInfo.stCd !== "99"
            ) {
              handleAllCheck(true);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    setCorpFormList();

    return () => setCheckItems([]);
  }, []);

  const handlePreviewClick = (e, form) => {
    const value = e.target.dataset.val;

    if (
      state.insert.reqTaskInfo.stCd === "10" ||
      state.insert.reqTaskInfo.stCd === "99"
    ) {
      if (checkItems.indexOf(value) === -1) {
        setCheckItems([...checkItems, value]);
      }
    }

    setPreviewPop({ isOpen: true, form: form });
  };

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              보험사별 위촉서류 최종원본을 확인합니다.
              <br></br>
              서류를 클릭하시면 해당 서류를 작성된 파일을 보실수 있으며, PDF로
              다운로드도 가능합니다.
            </b>
          </h5>
        </CContainer>
        <CCardBody className="bottom-card-body">
          {
            formList.filter((item) => item.AFCR_CAT_CD === '20').length > 0
            &&
            <CCol xs="12">
              <CFormGroup row>
                <a href="/inCar/inCar_menual.pdf" download><CButton color="primary">
                  FA전자문서 제출 메뉴얼 다운로드(클릭!)
                </CButton></a>
              </CFormGroup>
            </CCol>
          }
          <CFormGroup row>
          {
            formList.map((form) => {
              if (form.FORM_CAT_CD !== "20") return null;
              return (
                <CCol xs="12" className="text-left topSpace" key={form.FORM_NO}>
                  <div className="component-checkbox submission-box">
                    <label>
                      <input 
                        type="checkbox" 
                        id={`checkForm${form.FORM_NO}`}
                        name="singleCheck"
                        value={`checkForm${form.FORM_NO}`}
                        data-title={"정보제공동의서"}
                        onChange={(e) =>
                          handleSingleCheck(e.target.checked, e.target.value)
                        }
                        checked={
                          checkItems.includes(`checkForm${form.FORM_NO}`) ? true : false
                        }
                        disabled={
                          state.insert.reqTaskInfo.stCd !== "10" &&
                          state.insert.reqTaskInfo.stCd !== "99"
                            ? true
                            : false
                        }
                      />
                      <i />
                      <span className="txt-label">{form.FORM_NM}</span>
                    </label>
                    <CLabel
                      data-val={`checkForm${form.FORM_NO}`}
                      onClick={(e) => handlePreviewClick(e, form)}
                      className="showFile"
                    >
                      [보기]
                    </CLabel>
                  </div>
                </CCol>
              );
            })}
          { state.main.qualificationYn === '1' 
          && <>
              <CCol xs="12" className="text-left mt-3">
                <div>
                  <p>
                    <b>유자격자 고지사항</b>
                  </p>
                </div>
              </CCol>
          { formList.map((form) => {
            if (form.FORM_CAT_CD !== "30") return null;
            return (
              <CCol xs="12" className="text-left mb-1 mt-1" key={form.FORM_NO}>
                <div className="component-checkbox submission-box">
                  <label>
                    <input 
                      type="checkbox" 
                      id={`checkForm${form.FORM_NO}`}
                      value={`checkForm${form.FORM_NO}`}
                      name="singleCheck"
                      data-title={form.FORM_NM}
                      onChange={(e) =>
                        handleSingleCheck(e.target.checked, e.target.value)
                      }
                      checked={
                        checkItems.includes(`checkForm${form.FORM_NO}`)
                          ? true
                          : false
                      }
                      disabled={
                        state.insert.reqTaskInfo.stCd !== "10" &&
                        state.insert.reqTaskInfo.stCd !== "99"
                          ? true
                          : false
                      }
                    />
                    <i />
                    <span className="txt-label">{form.FORM_NM}</span>
                  </label>
                  <CLabel
                    data-val={`checkForm${form.FORM_NO}`}
                    onClick={(e) => handlePreviewClick(e, form)}
                    className="showFile"
                  >
                    [보기]
                  </CLabel>
                </div>
              </CCol>
              );
            })}
            </>
            }
            {
              state.main.qualificationYn === '0' &&
              formList.filter((item) => item.AFCR_CAT_CD === '10').length > 0
              &&
              <>
                <CCol xs="12" className="text-left mt-3">
              <div>
                <p>
                  <b>손해보험 보험사별 위촉서류</b>
                </p>
              </div>
              </CCol>
              {formList
                .filter((item) => item.AFCR_CAT_CD === '10')
                .map((form) => {
                  if (form.FORM_CAT_CD !== "10") return null;
                  return (
                    <CCol
                      xs={formList.length ? 12 : 6}
                      className="text-left mb-1 mt-1"
                      key={form.FORM_NO}
                    >
                      <div className="component-checkbox submission-box">
                        <label>
                          <input 
                            type="checkbox" 
                            id={`checkForm${form.FORM_NO}`}
                            name="singleCheck"
                            value={`checkForm${form.FORM_NO}`}
                            data-title={form.FORM_NM}
                            onChange={(e) =>
                              handleSingleCheck(e.target.checked, e.target.value)
                            }
                            checked={
                              checkItems.includes(`checkForm${form.FORM_NO}`)
                                ? true
                                : false
                            }
                            disabled={
                              state.insert.reqTaskInfo.stCd !== "10" &&
                              state.insert.reqTaskInfo.stCd !== "99"
                                ? true
                                : false
                            }
                          />
                          <i />
                          <span className="txt-label">{form.FORM_NM}</span>
                        </label>
                        {<CLabel
                          data-val={`checkForm${form.FORM_NO}`}
                          onClick={(e) => handlePreviewClick(e, form)}
                          className="showFile"
                        >[보기]</CLabel>}
                      </div>
                    </CCol>
                  );
                })}
              </>
            }
            {
              formList.filter((item) => item.AFCR_CAT_CD === '20').length > 0
              &&
              <>
                <CCol xs="12" className="text-left mt-3">
                  <div>
                    <p>
                      <b>생명보험 - 서류접수 보험사별 위촉서류</b>
                    </p>
                  </div>
                </CCol>
                {formList
                .filter((item) => item.AFCR_CAT_CD === '20')
                .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) === -1)
                .map((form) => {
                  if (form.FORM_CAT_CD !== "10") return null;
                  return (
                    <CCol
                      xs={formList.length ? 12 : 6}
                      className="text-left mb-1 mt-1"
                      key={form.FORM_NO}
                    >
                      <div className="component-checkbox submission-box">
                        <label>
                          <input 
                            type="checkbox" 
                            id={`checkForm${form.FORM_NO}`}
                            name="singleCheck"
                            value={`checkForm${form.FORM_NO}`}
                            data-title={form.FORM_NM}
                            onChange={(e) =>
                              handleSingleCheck(e.target.checked, e.target.value)
                            }
                            checked={
                              checkItems.includes(`checkForm${form.FORM_NO}`)
                                ? true
                                : false
                            }
                            disabled={
                              state.insert.reqTaskInfo.stCd !== "10" &&
                              state.insert.reqTaskInfo.stCd !== "99"
                                ? true
                                : false
                            }
                          />
                          <i />
                          <span className="txt-label">{form.FORM_NM}</span>
                        </label>
                        {form.AFCR_NO === '10003' || form.AFCR_NO === '10006'
                        ? <CLabel className="showFile">[-]</CLabel>
                        : <CLabel
                          data-val={`checkForm${form.FORM_NO}`}
                          onClick={(e) => handlePreviewClick(e, form)}
                          className="showFile"
                        >[보기]</CLabel>}
                      </div>
                      {/* <CFormGroup variant="checkbox" className="checkbox">
                        <CInputCheckbox
                          id={`checkForm${index + 1}`}
                          name="singleCheck"
                          value={`checkForm${index + 1}`}
                          data-title={form.FORM_NM}
                          onChange={(e) =>
                            handleSingleCheck(e.target.checked, e.target.value)
                          }
                          checked={
                            checkItems.includes(`checkForm${index + 1}`)
                              ? true
                              : false
                          }
                          disabled={
                            state.insert.reqTaskInfo.stCd !== "10" &&
                            state.insert.reqTaskInfo.stCd !== "99"
                              ? true
                              : false
                          }
                        />
                        <CLabel
                          variant="checkbox"
                          className="form-check-label"
                          htmlFor={`checkForm${index + 1}`}
                        >
                          {form.FORM_NM}
                        {form.AFCR_NO === '10026'
                        ? <CLabel className="showFile">[-]</CLabel>
                        : <CLabel
                          data-val={`checkForm${index + 1}`}
                          onClick={(e) => handlePreviewClick(e, form)}
                          className="showFile"
                        >[보기]</CLabel>}
                        </CLabel>
                      </CFormGroup> */}
                    </CCol>
                  );
                })}
                {formList
                .filter((item) => item.AFCR_CAT_CD === '20')
                .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) > -1).length > 0
                && <>
                  <CCol xs="12" className="text-left mt-3">
                    <div>
                      <p>
                        <b>생명보험 - 전자문서 보험사별 신청서</b>
                      </p>
                    </div>
                  </CCol>
                {formList
                .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) > -1)
                .map((form) => {
                  if (form.FORM_CAT_CD !== "10") return null;
                  return (
                    <CCol
                      xs={formList.length ? 12 : 6}
                      className="text-left mb-1 mt-1"
                      key={form.FORM_NO}
                    >
                      <div className="component-checkbox submission-box">
                        <label>
                          <input 
                            type="checkbox" 
                            id={`checkForm${form.FORM_NO}`}
                            name="singleCheck"
                            value={`checkForm${form.FORM_NO}`}
                            data-title={form.FORM_NM}
                            onChange={(e) =>
                              handleSingleCheck(e.target.checked, e.target.value)
                            }
                            checked={
                              checkItems.includes(`checkForm${form.FORM_NO}`)
                                ? true
                                : false
                            }
                            disabled={
                              state.insert.reqTaskInfo.stCd !== "10" &&
                              state.insert.reqTaskInfo.stCd !== "99"
                                ? true
                                : false
                            }
                          />
                          <i />
                          <span className="txt-label">{form.FORM_NM}</span>
                        </label>
                        {/* 221229 KB(라이프)생명 서류 미리보기 가능하게 변경 */}
                        <CLabel
                          data-val={`checkForm${form.FORM_NO}`}
                          onClick={(e) => handlePreviewClick(e, form)}
                          className="showFile"
                        >[보기]</CLabel>
                        {/* {form.AFCR_NO === '10026'
                        ? <CLabel className="showFile">[-]</CLabel>
                        : <CLabel
                          data-val={`checkForm${form.FORM_NO}`}
                          onClick={(e) => handlePreviewClick(e, form)}
                          className="showFile"
                        >[보기]</CLabel>} */}
                      </div>
                    </CCol>
                  )}
                )}
                </>}  
              </>
            }
            <CCol xs="12">
              <CFormGroup row></CFormGroup>
            </CCol>
            <CCol xs="12" className="text-left submission-all-confirm">
              <div className="component-checkbox submission-box">
                <label>
                  <input 
                    type="checkbox" 
                    id="checkAll"
                    name="checkAll"
                    value="checkAll"
                    onChange={(e) => handleAllCheck(e.target.checked)}
                    checked={
                      checkItems.length === 0
                        ? false
                        : checkItems.length === singleCheck.length
                        ? true
                        : false
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd !== "10" &&
                      state.insert.reqTaskInfo.stCd !== "99"
                        ? true
                        : false
                    }
                  />
                  <i />
                  <span className="txt-label">원본 서류의 내용을 모두 확인</span>
                </label>
              </div>
              {/* <CFormGroup variant="checkbox" className="checkbox">
                <CInputCheckbox
                  id="checkAll"
                  name="checkAll"
                  value="checkAll"
                  onChange={(e) => handleAllCheck(e.target.checked)}
                  checked={
                    checkItems.length === 0
                      ? false
                      : checkItems.length === singleCheck.length
                      ? true
                      : false
                  }
                  disabled={
                    state.insert.reqTaskInfo.stCd !== "10" &&
                    state.insert.reqTaskInfo.stCd !== "99"
                      ? true
                      : false
                  }
                />
                <CLabel
                  variant="checkbox"
                  className="form-check-label"
                  htmlFor="checkAll"
                >
                  <b>원본 서류의 내용을 모두 확인</b>
                </CLabel>
              </CFormGroup> */}
            </CCol>
          </CFormGroup>
        </CCardBody>
      </div>
      <TheFooter step={state.main.step} handleSubmission={handleSubmission} />
      {previewPop.isOpen && (
        <PreviewPop
          onClose={() => setPreviewPop({ isOpen: false })}
          form={previewPop.form}
        ></PreviewPop>
      )}
    </>
  );
};

export default SubmissionPage;
